// Side-agnostic equivalent of `views/suppliersBalance/enums/suppliersBalanceFilterType.ts`;
// feature-owned since no generic version exists yet.
export enum BalanceFilterType {
  Account = 'account',
  BalanceDirection = 'balanceDirection',
}
